import React, { useState, useEffect } from "react";
import { emptyAvatar } from "../../imagepath";
import { getFile } from "../../../lib/file";
import { getIdData } from "../../../lib/studentinfo"

export default function StudentInfoBox({slug}) {

    const [studentInfo, setStudentInfo] = useState(0);
    const [avatar, setAvatar] = useState();

    async function GetData() {
        const std = await getIdData(slug);
        setStudentInfo(std);

        if (std[0]?.avatar_url) {
        const avt = await getFile(std[0]?.avatar_url);
        setAvatar(avt.publicUrl);
        }

    }
  
  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="settings-widget">
              <div className="settings-inner-blk p-0">
                {studentInfo &&

                  <div className="row m-2">
                    <div className="col-3">
                      <div className="student-img" >
                        <img
                          className="rounded-circle float-start" style={{ height: "100px" }}
                          alt="Students Info"
                          src={avatar ? avatar :emptyAvatar}
                        />
                      </div>
                    </div>
                    <div className="col-9 align-items-center mt-3">
                      <h3>{studentInfo[0]?.name + " " + studentInfo[0]?.surname}</h3>
                      <p>
                        {studentInfo[0]?.schoolname + " - " + studentInfo[0]?.class}
                      </p>
                    </div>
                  </div>

                }
              </div>
            </div>
  )
}
